export const revenueApiEndpoints = {
  getSettings: `/revenue/settings`,
  updateSetting: (type: string) => `/revenue/settings/${type}`,
  getStats: `/revenue/stats`,
};
